module.exports = __webpack_public_path__ + "img/SHN.9538e811.svg";